<div class="breadcrumbs">
  <span class="title" *ngIf="isDettaglio">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Dettaglio Intervento </span>
  <span class="title" *ngIf="isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Modifica Intervento </span>
</div>
<hr>

<div class="titolo flex-row-titolo">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate('back')">
      <mat-icon class="middle">keyboard_arrow_left</mat-icon>
    </button>
    <div class="denom">
    <span class="h5 upp">Dettaglio intervento </span>
  </div>
  </div>

  <div class="combo">
    <button *ngIf="statoInt =='ATTFIN' && isModifica"  mat-flat-button color='accent' class="pers3 mleft" (click)="openDialogMotivazione(1)">SEGNALAZIONE IDONEA</button>
    <button *ngIf="statoInt =='ATTFIN' && isModifica"  mat-flat-button color='accent' class="pers3 mleft" (click)="openDialogMotivazione(2)">SEGNALAZIONE NON IDONEA</button>
    <button *ngIf="statoInt =='IDONEO' && isModifica"  mat-flat-button color='accent' class="pers3 mleft" (click)="openDialogMotivazione(3)">PROPONI FINANZIAMENTO </button>
    <button *ngIf="statoInt =='PROFIN' && isModifica"  mat-flat-button color='accent' class="pers3 mleft" (click)="openDialogMotivazione(4)">FINANZIA</button>
    <button *ngIf="statoInt =='PROFIN' && isModifica"  mat-flat-button color='accent' class="pers3 mleft" (click)="openDialogMotivazione(5)">RESPINGI</button>
    <button *ngIf="statoInt =='FINANZ' && isModifica"  mat-flat-button color='accent' class="pers3 mleft" (click)="openDialogMotivazione(6)">ESPUNGI</button>
    <!-- <button *ngIf="statoInt =='PROFIN'"  mat-stroked-button color='basic' class="pers2 mleft" (click)="openDialogMotivazione(7)">RIMODULA</button> -->
    <!-- <button *ngIf="statoInt =='PROFIN' || statoInt =='RESPIN' || statoInt =='FINANZ' || statoInt =='ATTLIQ' || statoInt =='LIQUID'"  mat-flat-button color='accent' class="pers3 mleft">VISUALIZZA STORICO RIMODULAZIONI</button> -->
  </div>

</div>

<div class="pers titles">
  <span class="title">
    DETTAGLIO INTERVENTO
  </span>
</div>

<div class="flex-row-pers" [formGroup]="formQuadroA">

  <mat-form-field [ngClass]="{'mat-change':isModifica}" color="accent" appearance="fill" class='std'>
    <mat-label class="big">Stato</mat-label>

    <mat-select [formControlName]="'stato'">
      <mat-option value="ATTFIN">In attesa di finanziamento</mat-option>
      <mat-option value="PRERES">Preventivamente respinto</mat-option>
      <mat-option value="IDONEO">Idoneo</mat-option>
      <mat-option value="PROFIN">In proposta di finanziamento</mat-option>
      <mat-option value="RESPIN">Respinto</mat-option>
      <mat-option value="FINANZ">Finanziato</mat-option>
      <mat-option value="ESPUNT">Espunto</mat-option>
      <mat-option value="ATTLIQ">In attesa di liquidazione</mat-option>
      <mat-option value="LIQUID">Liquidato</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="statoInt === 'FINANZ'" [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='dem'>
    <mat-label class="big">Descrizione autorizzazione intervento</mat-label>
    <input matInput [formControlName]="'descriAutorizIntervento'">
  </mat-form-field>

  <mat-form-field  *ngIf="statoInt === 'RESPIN' || statoInt === 'PRERES' " [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='dem'>
    <mat-label class="big">Descrizione rifiuto intervento</mat-label>
    <input matInput [formControlName]="'descriRifiutoIntervento'">
  </mat-form-field>

  <mat-form-field  *ngIf="statoInt === 'PROFIN'" [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='dem'>
    <mat-label class="big">Descrizione finanziamento intervento</mat-label>
    <input matInput [formControlName]="'descriFinanzIntervento'">
  </mat-form-field>

  <mat-form-field  *ngIf="statoInt === 'ESPUNT'" [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='dem'>
    <mat-label class="big">Descrizione espunzione</mat-label>
    <input matInput [formControlName]="'descriEspunto'">
  </mat-form-field>

  <mat-form-field *ngIf="statoInt === 'ESPUNT' || statoInt === 'PROFIN' || (statoInt === 'RESPIN' || statoInt === 'PRERES') || statoInt === 'FINANZ'" 
    [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
    <mat-label class="big">Descrizione attività intervento</mat-label>
    <textarea matInput [formControlName]="'descrizIntervento'" cdkTextareaAutosize #autosize="cdkTextareaAutosize"></textarea>
  </mat-form-field>

  <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
    <mat-label class="big">Ente attuatore</mat-label>
    <input matInput [formControlName]="'enteAttuatore'">
  </mat-form-field>

  <mat-form-field class="invisible">
    <input matInput>
  </mat-form-field>

  <mat-form-field *ngIf="statoInt === 'ATTFIN'" 
    [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
      <mat-label class="big">Descrizione attività intervento</mat-label>
      <textarea matInput [formControlName]="'descrizIntervento'" cdkTextareaAutosize #autosize="cdkTextareaAutosize"></textarea>
  </mat-form-field>
</div>

<div class="flex-row">
  <mat-tab-group class="pers-tab-group" [color]="'accent'" mat-align-tabs="start">

    <mat-tab >
      <ng-template mat-tab-label>
        <strong>QUADRO A</strong>
      </ng-template>
      <div class="flex-row salva">
        <button  mat-flat-button color='accent' *ngIf="isModifica" (click)="upsertIntervento()" class="pers3">SALVA MODIFICHE</button>
      </div>

      <div class="flex-row-pers" [formGroup]="formQuadroA">

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}" appearance="fill" color='accent' class='std'>
          <mat-label class="big">Origine del danno</mat-label>
          <input matInput [formControlName]="'idOrigDanno'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}" appearance="fill" color='accent' class='std'>
          <mat-label class="big">Origine del danno</mat-label>
          <input matInput [formControlName]="'descrizioneOrigDanno'">
        </mat-form-field>

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Classe attività intervento</mat-label>
          <input matInput [formControlName]="'idClasse'" >
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Classe attività intervento</mat-label>
          <input matInput [formControlName]="'descrizioneAttIntv'" >
        </mat-form-field>

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Priorità dell' intervento</mat-label>
          <input matInput [formControlName]="'idPriorita'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Priorità dell' intervento</mat-label>
          <input matInput [formControlName]="'descrizionePriorita'">
        </mat-form-field>

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Tipo attività opera</mat-label>
          <input matInput [formControlName]="'idTpAttivita'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='totSpace'>
          <mat-label class="big">Tipo attività opera</mat-label>
          <input matInput [formControlName]="'descrizioneTpAttiv'">
        </mat-form-field>

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Tipo bene oggetto di intervento</mat-label>
          <input matInput [formControlName]="'idTpBeneDanneggiato'">
        </mat-form-field>

        <mat-form-field  [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='moreSpace'>
          <mat-label class="big">Tipo bene oggetto di intervento</mat-label>
          <input matInput [formControlName]="'descrizioneTpBene'">
        </mat-form-field>

        <mat-form-field   [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Bene culturale vincolato</mat-label>
          <mat-select [formControlName]="'flBeneCultVincolo'">
            <mat-option [value]="true">Sì</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='totSpace'>
          <mat-label class="big">Uso descrizione bene danneggiato</mat-label>
          <input matInput [formControlName]="'usoBeneDanneggiato'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Località attivita intervento</mat-label>
          <input matInput [formControlName]="'localita'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Sezione</mat-label>
          <input matInput [formControlName]="'datCatasSezioni'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Foglio</mat-label>
          <input matInput [formControlName]="'datCatasFoglio'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Mappale</mat-label>
          <input matInput [formControlName]="'datCatasMappale'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Coordinate Longitudine</mat-label>
          <input matInput [formControlName]="'Coordinate_GPS_ETRF_2000_x'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Coordinate Latitudine</mat-label>
          <input matInput [formControlName]="'Coordinate_GPS_ETRF_2000_y'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Numero persone sfollate</mat-label>
          <input matInput [formControlName]="'numPersoneSfollate'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Numero persone sistemate a spesa dell'ente</mat-label>
          <input matInput [formControlName]="'numPersSistEnte'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Numero persone sistemate autonomamente</mat-label>
          <input matInput [formControlName]="'numPersSistAuto'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Numero persone decedute</mat-label>
          <input matInput [formControlName]="'numPersSistDecedute'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">N. ore straordinario effettuate durante emergenza dipendenti pubblici</mat-label>
          <input matInput [formControlName]="'numOreStraordinarie'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Importo complessivo per il ripristino</mat-label>
          <input matInput [formControlName]="'impComplessivoRich'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Importo spese già sostenute</mat-label>
          <input matInput [formControlName]="'impSpeseGiaSost'">
        </mat-form-field>

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Stato esecuzione intervento</mat-label>
          <input matInput [formControlName]="'idStatoEsecuz'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Stato esecuzione intervento</mat-label>
          <input matInput [formControlName]="'descrizioneStatoEsecuz'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Data inizio lavori</mat-label>
          <input matInput [matDatepicker]="picker4" [formControlName]="'dataInizioLav'">
          <mat-datepicker-toggle  [disabled]="true" matSuffix [for]="picker4"></mat-datepicker-toggle>
          <mat-datepicker #picker4></mat-datepicker>
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Data fine lavori</mat-label>
          <input matInput [matDatepicker]="picker5" [formControlName]="'dataFineLav'">
          <mat-datepicker-toggle [disabled]="true" matSuffix [for]="picker5"></mat-datepicker-toggle>
          <mat-datepicker #picker5></mat-datepicker>
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Presenza altri finanziamenti</mat-label>
          <mat-select [formControlName]="'flAltriFinanz'">
            <mat-option [value]="true">Sì</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Nominativo finanziatore</mat-label>
          <input matInput [formControlName]="'nominativoAltriFinanz'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Quota altri finanziamenti</mat-label>
          <input matInput [formControlName]="'quotaAltriFinanz'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Risarcibile da assicurazione</mat-label>
          <mat-select [formControlName]="'flRisarcibile'">
            <mat-option [value]="true">Sì</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Importo risarcibile stimato</mat-label>
          <input matInput [formControlName]="'impRisarcibile'">
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Importo premio assicurativo ultimi</mat-label>
          <input matInput [formControlName]="'impVersPremioAss'">
        </mat-form-field>
      </div>

      <hr>

      <!-- CAMPI DPGE NON EDITABILI -->
      <div class="flex-row-pers" [formGroup]="formQuadroA">

        <mat-form-field hidden [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Stato progettuale</mat-label>
          <input matInput [formControlName]="'idStatoProgett'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.idStatoProgett.errors && this.formQuadroA.controls.idStatoProgett.touched">
            <mat-error *ngIf="this.formQuadroA.controls.idStatoProgett.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Stato progettuale</mat-label>
          <input matInput [formControlName]="'descrizioneStatoProgett'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.idStatoProgett.errors && this.formQuadroA.controls.idStatoProgett.touched">
            <mat-error *ngIf="this.formQuadroA.controls.idStatoProgett.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">CUP intervento</mat-label>
          <input matInput [formControlName]="'CUPIntervento'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.CUPIntervento.errors && this.formQuadroA.controls.CUPIntervento.touched">
            <mat-error *ngIf="this.formQuadroA.controls.CUPIntervento.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}" class='std' color="accent" appearance="fill">
          <mat-label class="big">Data nomina RUP</mat-label>
          <input matInput [matDatepicker]="picker1" [formControlName]="'dataNominaRUP'">
          <mat-datepicker-toggle [disabled]="true" matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          <!-- <mat-error *ngIf="this.formQuadroA.controls.dataNominaRUP.errors && this.formQuadroA.controls.dataNominaRUP.touched">
            <mat-error *ngIf="this.formQuadroA.controls.dataNominaRUP.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Nominativo RUP</mat-label>
          <input matInput [formControlName]="'nominativoRUP'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.nominativoRUP.errors && this.formQuadroA.controls.nominativoRUP.touched">
            <mat-error *ngIf="this.formQuadroA.controls.nominativoRUP.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Modalità affidamento lavori principali</mat-label>
          <input matInput [formControlName]="'modalitaAffidamento'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.modalitaAffidamento.errors && this.formQuadroA.controls.modalitaAffidamento.touched">
            <mat-error *ngIf="this.formQuadroA.controls.modalitaAffidamento.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Impresa aggiudicataria</mat-label>
          <input matInput [formControlName]="'impresaAggiudicataria'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.impresaAggiudicataria.errors && this.formQuadroA.controls.impresaAggiudicataria.touched">
            <mat-error *ngIf="this.formQuadroA.controls.impresaAggiudicataria.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  appearance="fill" color='accent' class='std'>
          <mat-label class="big">Numero atto affidamento lavori principali</mat-label>
          <input matInput [formControlName]="'numAttoAffidamento'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.numAttoAffidamento.errors && this.formQuadroA.controls.numAttoAffidamento.touched">
            <mat-error *ngIf="this.formQuadroA.controls.numAttoAffidamento.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Data atto affidamento lavori principali</mat-label>
          <input matInput [matDatepicker]="picker2" [formControlName]="'dataAttoAffidamento'">
          <mat-datepicker-toggle [disabled]="true" matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <!-- <mat-error *ngIf="this.formQuadroA.controls.dataAttoAffidamento.errors && this.formQuadroA.controls.dataAttoAffidamento.touched">
            <mat-error *ngIf="this.formQuadroA.controls.dataAttoAffidamento.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Data affidamento lavori</mat-label>
          <input matInput [matDatepicker]="picker3" [formControlName]="'dataAffidamento'">
          <mat-datepicker-toggle [disabled]="true" matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
          <!-- <mat-error *ngIf="this.formQuadroA.controls.dataAffidamento.errors && this.formQuadroA.controls.dataAffidamento.touched">
            <mat-error *ngIf="this.formQuadroA.controls.dataAffidamento.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Data certificazione ultimazione lavori</mat-label>
          <input matInput [matDatepicker]="picker6" [formControlName]="'dataCertifUltimiLav'">
          <mat-datepicker-toggle [disabled]="true" matSuffix [for]="picker6"></mat-datepicker-toggle>
          <mat-datepicker #picker6></mat-datepicker>
          <!-- <mat-error *ngIf="this.formQuadroA.controls.dataCertifUltimiLav.errors && this.formQuadroA.controls.dataCertifUltimiLav.touched">
            <mat-error *ngIf="this.formQuadroA.controls.dataCertifUltimiLav.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>
      </div>

<hr>

<!-- CAMPI ECONOMIE -->
        <div class="flex-row-pers" [formGroup]="formQuadroA">
        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Var. Progetto</mat-label>
          <input matInput [formControlName]="'econVarProgetto'">
          <mat-error *ngIf="this.formQuadroA.controls.econVarProgetto.errors && this.formQuadroA.controls.econVarProgetto.touched">
            <mat-error *ngIf="this.formQuadroA.controls.econVarProgetto.errors.pattern">
              Il campo valuta deve avere due cifre decimali -> es. 1000,00
            </mat-error>
            <!-- <mat-error *ngIf="this.formQuadroA.controls.econVarProgetto.errors.required">Campo obbligatorio
          </mat-error> -->
          </mat-error>
        </mat-form-field>


        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Spese dichiarate</mat-label>
          <input matInput [formControlName]="'econSpeseDich'">
          <mat-error *ngIf="this.formQuadroA.controls.econSpeseDich.errors && this.formQuadroA.controls.econSpeseDich.touched">
            <mat-error *ngIf="this.formQuadroA.controls.econSpeseDich.errors.pattern">
              Il campo valuta deve avere due cifre decimali -> es. 1000,00
            </mat-error>
            <!-- <mat-error *ngIf="this.formQuadroA.controls.econSpeseDich.errors.required">Campo obbligatorio
          </mat-error> -->
          </mat-error>
        </mat-form-field>


        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Richieste in sostituzione</mat-label>
          <input matInput  [formControlName]="'econRichRest'">
          <mat-error *ngIf="this.formQuadroA.controls.econRichRest.errors && this.formQuadroA.controls.econRichRest.touched">
            <mat-error *ngIf="this.formQuadroA.controls.econRichRest.errors.pattern">
              Il campo valuta deve avere due cifre decimali -> es. 1000,00
            </mat-error>
            <!-- <mat-error *ngIf="this.formQuadroA.controls.econRichRest.errors.required">Campo obbligatorio
          </mat-error> -->
          </mat-error>
        </mat-form-field>


        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Richieste già presenti in blocco</mat-label>
          <input matInput  [formControlName]="'econGiaRres'">
          <mat-error *ngIf="this.formQuadroA.controls.econGiaRres.errors && this.formQuadroA.controls.econGiaRres.touched">
            <mat-error *ngIf="this.formQuadroA.controls.econGiaRres.errors.pattern">
              Il campo valuta deve avere due cifre decimali -> es. 1000,00
            </mat-error>
            <!-- <mat-error *ngIf="this.formQuadroA.controls.econGiaRres.errors.required">Campo obbligatorio
          </mat-error> -->
          </mat-error>
        </mat-form-field>


        <mat-form-field [ngClass]="{'mat-change':isModifica}"  class='std' color="accent" appearance="fill">
          <mat-label class="big">Decreti economie/ NR anno</mat-label>
          <input matInput  [formControlName]="'decretiEconAnno'">
          <!-- <mat-error *ngIf="this.formQuadroA.controls.decretiEconAnno.errors && this.formQuadroA.controls.decretiEconAnno.touched">
            <mat-error *ngIf="this.formQuadroA.controls.decretiEconAnno.errors.required">Campo obbligatorio
            </mat-error>
          </mat-error> -->
        </mat-form-field>

      </div>

    </mat-tab>

    <mat-tab *ngIf="!hidden">

      <ng-template mat-tab-label>
        <strong>AREA GECOS</strong>
      </ng-template>

    </mat-tab>
    <mat-tab  *ngIf="!hidden">

      <ng-template mat-tab-label>
        <strong>AREA NUSICO</strong>
      </ng-template>

    </mat-tab>
  </mat-tab-group>
</div>
